import { render } from "./BlockCollector.vue?vue&type=template&id=d8b325fa"
import script from "./BlockCollector.vue?vue&type=script&lang=js"
export * from "./BlockCollector.vue?vue&type=script&lang=js"
script.render = render

export default script